import { useState } from 'react';
import {css} from "@emotion/react";
import PropTypes from "prop-types";

import Video from "./Video";
import CmsImageLoader from "./CmsImageLoader";
import Header from "./Header";
import { ButtonPill } from "@/base";
import SVG from "react-inlinesvg";
import {mobileDetect} from "../../util/mobileDetect";

const FlexCard = ({
                    entity,
                    columnCount,
                    childIndex,
                    original
                  }) => {

  const [videoActive, setVideoActive] = useState(false);
  const image = entity.image;
  const isMobile = mobileDetect()

  const colClass = () => {
    let classes = childIndex !== 2 ? `size-ns-1of2 size-lg-1of${columnCount}` : `size-lg-1of${columnCount}`;
    return `aspect size-full columns--${columnCount} ${classes} d-flex align-items-center justify-content-center`;
  }

  // Text theme

  const textDarkColor = {
    color: '#000',
    textShadow: "0 0 1.5rem rgb(255 255 255 / 80%)",
  };

  const textLightColor = {
    color: '#fff',
    textShadow: "0 0 1.5rem rgb(0 0 0 / 80%)",
  };

  const textOptions = [entity.text_theme?.value === "light" ? textLightColor : textDarkColor];

  const buildHeader = () => {
    if (entity.title?.value) {

      textOptions[0].marginBottom = '0px !important';

      return (
          <Header tag={'h3'} style={textOptions}>
            <div data-aos="fade-up" data-aos-delay={200}>{entity.title.value}</div>
          </Header>
      )
    }
  }

  const buildCopy = (el) => {
    if(el.value){
      return <div key={el.id} dangerouslySetInnerHTML={{__html: el.value}} css={textOptions}/>
    }
  }

  const buildButton = (el) => {

    let call_to_action = el.value?.elements;
    let button_url = call_to_action.find(el=>el.render_name==='button_url');
    let button_text = call_to_action.find(el=>el.render_name==='button_text');
    let button_theme = call_to_action.find(el=>el.render_name==='button_theme')

    if(!button_text) return;

    return (
        <div key={el.id} className={'mt-3 mb-2'}>
          <ButtonPill to={button_url.value} buttonTheme={button_theme.value} noBorder={true}>
            {button_text.value}
          </ButtonPill>
        </div>
    )

  }

  const buildSingleButton = () => {

    if(!entity.call_to_action) return;

    let element = Array.isArray(entity.call_to_action) ? entity.call_to_action[0] : entity.call_to_action;

    return (
        <div className={'mb-0'}>
          <ButtonPill to={element.button_url.value} buttonTheme={element.button_theme.value} noBorder={true}
                      data-aos={'fade-up'} data-aos-delay={200}>{element.button_text.value}</ButtonPill>
        </div>
    )

  }

  const buildContent = () => {

    // flexible expandable content card
    if(columnCount === 3){

      return original?.value?.elements.map((el) => {
        if(el.render_name === 'text') return buildCopy(el);
        if(el.render_name === 'call_to_action') return buildButton(el)
      });

    }

  }

  const buildVideoPlayer = () => {

    // console.log(entity)

    if(entity.video){
      return (
          <>
            <Video video_id={entity.video.video_id.value} video_provider={entity.video.video_provider.value} autoplay={true} unmute={true}/>
            <button className={'closeIcon'} onClick={()=>setVideoActive(false)}>
              <SVG src={'/images/lac-icons/lac-nav-close.svg'} cacheRequests={true} />
            </button>
          </>
      )
    }
  }

  const getContentWrapper = () => {

    let overlayCss = {
      height: '100%',
      width: '100%',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    }

    if(entity.text_theme?.value === 'light'){
      overlayCss.background = 'rgba(0,0,0,0.3)'
    }

    if(columnCount !== 2){

      overlayCss.position = 'relative';

      let styles = css(`
          > *:last-child{
          margin-bottom: 0 !important
        }
      `)

      //Hover overlay layout, content flexible based on original network entities response
      return (
          <div css={overlayCss} className={`card posRelative d-flex align-items-center justify-content-center minH-100 ${isMobile && 'mobile'}`}>
            <span className={`d-flex flex-column align-items-center p-2 p-lg-4 text-center`} css={styles}>

              {buildHeader()}

              <div className={'hoverCard pt-3'}>
                {buildContent()}
              </div>

            </span>
          </div>
      )
    } else {

      // lower content layout, content based on reduced entitity renderer
      return (
        <>

          {videoActive && buildVideoPlayer()}

          {!videoActive && (
              <div css={overlayCss} className={'posRelative d-flex align-items-end minH-100'}>
                <span className={'size-full p-2 p-lg-4 d-flex flex-row justify-content-between'} >

                  {entity.video && (
                      <button className={'playIcon'} onClick={()=>setVideoActive(true)}>
                        <SVG src={'/images/lac-icons/lac-nav-play-button.svg'} cacheRequests={true} />
                      </button>
                  )}

                  {buildHeader()}

                  {buildSingleButton()}

                </span>
              </div>
            )
          }
        </>
      )
    }
  }

  return (
      <div className={colClass()} data-aos="fade-in" data-aos-delay={childIndex * 200}>

        <CmsImageLoader
            css={{ width: "100%", height: "100%", objectFit: "cover", position: "absolute" }}
            url={image.image_url.value} alt={image.image_alt?.value}/>

        {getContentWrapper()}

      </div>

  );
};

FlexCard.propTypes = {
  entity: PropTypes.object,
  columnCount: PropTypes.number,
  childIndex: PropTypes.number,
  original: PropTypes.object
};

export default FlexCard;
